import React from 'react';

import BlockAccessPage from '../../../../../components/BlockAccess/BlockAccessPage';
import {checkIfHasPermissions} from '../../../../../components/Menu/Utils/commonFunctions';
import AverageTable from '../../../../../components/Table/AverageTable';
import Tabs from '../../../../../components/Tabs/Tabs';
import {PermissionEnum} from '../../../../../constants/permissionsEnum';
import TranslatedText from '../../../../../libraries/I18N/TranslatedText';
import {accessModule} from '../../../../../store/companyStore/companyDetailsStore';
import {shouldBlockModuleAccess} from '../../../../../utils/SubscriptionHelper';

const CapitalGoods: React.FC<{
  selectedYear: string;
  facilityId: string;
}> = ({selectedYear, facilityId}) => {
  const SCTab = [
    {
      id: 'capAverage',
      name: <TranslatedText translationKey="Average Method" />,
      component: shouldBlockModuleAccess(accessModule.scope3) ? (
        <BlockAccessPage />
      ) : (
        <AverageTable selectedYear={selectedYear} facilityId={facilityId} />
      ),
      hidden: !checkIfHasPermissions(
        PermissionEnum.OrgManagerCapitalGoodsAverageMethod
      )
    },
    {
      id: 'capSupplier',
      name: <TranslatedText translationKey="Supplier Specific Method" />,
      component: shouldBlockModuleAccess(accessModule.scope3) ? (
        <BlockAccessPage />
      ) : (
        <AverageTable
          selectedYear={selectedYear}
          facilityId={facilityId}
          isAverage={false}
        />
      ),
      hidden: !checkIfHasPermissions(
        PermissionEnum.OrgManagerCapitalGoodsSupplierSpecificMethod
      )
    }
  ].filter((item) => !item.hidden);

  return (
    <>
      <Tabs array={SCTab} type="card" />
    </>
  );
};

export default CapitalGoods;
